import { ALLOCATION_PRICING_METHOD, RATE_CARD_TYPE_PRICING, TShipmentOrder } from '@types';
import { getPricingMethodFromCargoType } from './getPricingMethodFromCargoType';

/** The allocation form's default: a multi-rate shipment is costed as booked, PER_ITEM on v2; anything else by cargo type. */
export const getAllocationPricingMethod = (shipment: TShipmentOrder): ALLOCATION_PRICING_METHOD | RATE_CARD_TYPE_PRICING | null =>
	shipment.rate?.is_multi_rate
		? RATE_CARD_TYPE_PRICING.PER_ITEM
		: getPricingMethodFromCargoType(shipment.cargo_type_id);
